import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          漫画分类
        </h2>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
        {categories.slice(1).map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-2.5 p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
              <i className={`${cat.icon} text-lg`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
              {cat.name}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}